import React, { Component } from 'react'
import Header from "./Common/Header/Header";
import "./Common/Header/Header.css";
import "../src/Transactions/Transaction.css";
import barcode from "./assets/images/Barcode.jpeg";
import Constant from './constant/Constant';

class Barcode extends Component {
    render() {
        return (
          <>
            <div className="App">
              <Header />
              <div className="image">
                <img src={Constant.VIDEO_BASE_URL + 'Barcode.jpeg'} alt="BigCo Inc. logo" className="barcode" />
                {/* <img src={barcode} alt="BigCo Inc. logo" className="barcode"  /> */}
              </div>
            </div>
          </>
        );
    }
}
export default Barcode;